<template lang="pug">
#modal-visualizacao-laudo
    el-dialog(
        :title='dialogTitle',
        width='500px',
        :visible.sync='show',
        @close='closeDialog'
    )
        .mapa(v-if='informacoesLaudo.geometriaTerritorio')
            Mapa(
                :mapLayersConfigs='layersMaps',
                :mapConfig='mapConfig',
                :height='"100%"',
                :idMapa='"mapaVizualizacaoLaudo"',
                locked
            )

        p(v-if='camposLaudo.baseDados')
            b {{ $t('mensagens.laudos.baseDeDados') }}:
            | {{ camposLaudo.baseDados }}

        p(v-if='camposLaudo.tipoInsumo')
            b {{ $t('mensagens.laudos.tipoDeInsumo') }}:
            | {{ camposLaudo.tipoInsumo }}

        p(v-if='camposLaudo.nomeTerritorio')
            b {{ $t('mensagens.laudos.territorio') }}:
            | {{ camposLaudo.nomeTerritorio }}

        p(v-if='camposLaudo.localidadeTerritorio')
            b {{ $t('mensagens.laudos.localidade') }}:
            | {{ camposLaudo.localidadeTerritorio }}

        p(v-if='camposLaudo.areaTerritorio')
            b {{ $t('mensagens.laudos.areaHa') }}:
            | {{ camposLaudo.areaTerritorio }}

        p(v-if='informacoesLaudo.car && informacoesLaudo.car.codigo')
            b CAR:
            | {{ informacoesLaudo.car.codigo }}

        p(v-if='camposLaudo.referenciaBacen')
            b Refbacen:
            | {{ camposLaudo.referenciaBacen }}

        p(v-if='informacoesLaudo.descricao')
            b {{ $t('mensagens.laudos.descricao') }}:
            | {{ camposLaudo.descricao }}

        p(v-if='camposLaudo.numeroOperacao')
            b {{ $t('mensagens.laudos.numeroDaOperacao') }}:
            | {{ camposLaudo.numeroOperacao }}

        p(v-if='camposLaudo.tipoEmpreendimento')
            b {{ $t('mensagens.laudos.tipoDeEmpreendimento') }}:
            | {{ camposLaudo.tipoEmpreendimento }}

        p(v-if='camposLaudo.culturaEsperada')
            b {{ $t('mensagens.laudos.cultura') }}:
            | {{ camposLaudo.culturaEsperada }}

        p(v-if='camposLaudo.areaFinanciadaHa')
            b {{ $t('mensagens.laudos.areaFinanciada') }}:
            | {{ camposLaudo.areaFinanciadaHa }}

        p(v-if='camposLaudo.producaoEsperadaTon')
            b {{ $t('mensagens.laudos.producaoEsperada') }}:
            | {{ camposLaudo.producaoEsperadaTon }}

        p(v-if='camposLaudo.produtividadeEsperadaScHa')
            b {{ $t('mensagens.laudos.expectativaDeProdutividade') }}:
            | {{ camposLaudo.produtividadeEsperadaScHa }}

        p(v-if='camposLaudo.dataPlantioFormatado')
            b {{ $t('mensagens.laudos.dataProgramadaDePlantio') }}:
            | {{ camposLaudo.dataPlantioFormatado }}

        p(v-if='camposLaudo.dataColheitaFormatado')
            b {{ $t('mensagens.laudos.dataProgramadaDeColheita') }}:
            | {{ camposLaudo.dataColheitaFormatado }}

        p(v-if='camposLaudo.nomeRepresentante && !camposLaudo.emitente')
            b {{ $t('mensagens.laudos.produtor') }}:
            | {{ camposLaudo.nomeRepresentante }} ({{ camposLaudo.cpfCnpjRepresentante }})

        p(v-if='camposLaudo.nomeRepresentante && camposLaudo.emitente')
            b {{ $t('mensagens.laudos.emitente') }}:
            | {{ camposLaudo.nomeRepresentante }} ({{ camposLaudo.cpfCnpjRepresentante }})

        p(v-if='camposLaudo.nomeCredor')
            b {{ $t('mensagens.laudos.credor') }}:
            |
            | {{ camposLaudo.nomeCredor }} ({{ camposLaudo.cpfCnpjCredor }})

        p(v-if='camposLaudo.dataReferenciaFormatado')
            b {{ $t('mensagens.laudos.dataReferenciaParaCriacaoDeLaudo') }}:
            | {{ camposLaudo.dataReferenciaFormatado }}

        p(v-if='camposLaudo.qdeEmitentes')
            b {{ $t('mensagens.laudos.quantidadeDeEmitentes') }}:
            | {{ camposLaudo.qdeEmitentes }}

        p(v-if='camposLaudo.cpr')
            b {{ $t('mensagens.laudos.cpr') }}:
            | {{ camposLaudo.cpr }}

        p(v-if='camposLaudo.matricula')
            b {{ $t('mensagens.laudos.matricula') }}:
            | {{ camposLaudo.matricula }}

        p(v-if='camposLaudo.areaPenhor')
            b {{ $t('mensagens.laudos.areaDePenhor') }}:
            | {{ camposLaudo.areaPenhor }}

        p(v-if='camposLaudo.formatoCoordenadas')
            b {{ $t('mensagens.laudos.formatoDeExibicaoDasCoordenadas') }}:
            | {{ camposLaudo.formatoCoordenadas }}
        
        p(v-if='camposLaudo.dataInicioCobertura')
            b {{ $t('mensagens.laudos.dataInicioCobertura') }}:
            | {{ camposLaudo.dataInicioCobertura }}

        p(v-if='camposLaudo.dataFimCobertura')
            b {{ $t('mensagens.laudos.dataFimCobertura') }}:
            | {{ camposLaudo.dataFimCobertura }}

        p.margin-p(v-if='informacoesLaudo.representantes && informacoesLaudo.representantes.length')
            b {{ $t('mensagens.laudos.pessoaS') }}:
            ul.lista-cliente
                li.lista(v-for='rep in informacoesLaudo.representantes')
                    span {{ rep.nomeRepresentante }} - {{ $t('mensagens.comuns.documento') }}: {{ numeralStringFormatToCpfCnpj(rep.cpfCnpjRepresentante) }}

        p.margin-p(v-if='camposLaudo.carsVinculados && camposLaudo.carsVinculados.length')
            b {{ $t('mensagens.laudos.carsVinculados') }}:
            ul.lista-car
                li.lista(v-for='car in camposLaudo.carsVinculados' :key='car')
                    span {{ car }}

        p.margin-p(v-if='camposLaudo.carsTerritorio && camposLaudo.carsTerritorio.length')
            b {{ $t('mensagens.laudos.carsVinculados') }}:
            ul.lista-car
                li.lista(v-for='car in camposLaudo.carsTerritorio' :key="car.codigo")
                    span {{ car.codigo }}

        p.margin(v-if='camposLaudo.proprietarios && camposLaudo.proprietarios.length')
            b {{ $t('mensagens.laudos.pessoaS') }}:
            ul.lista-car
                li.lista(
                    v-for='proprietario in camposLaudo.proprietarios'
                )
                    span {{ proprietario.nomeProprietario }} ({{ numeralStringFormatToCpfCnpj(proprietario.documentoProprietario) }})

        p.margin-p.margin-p-block(v-if='camposLaudo.representantesTerritorio && camposLaudo.representantesTerritorio.length')
            b {{ $t('mensagens.laudos.representanteS') }}:
            ul.lista(v-for="rep in camposLaudo.representantesTerritorio" :key="rep")
                li {{ rep }}

        p.margin-p(v-if='camposLaudo.arquivosLaudos && camposLaudo.arquivosLaudos.length > 0')
            b {{ $t('mensagens.laudos.arquivosEnviados') }}:
            div(v-for='arq in camposLaudo.arquivosLaudos' :key='arq.id')
                .link
                    i.mdi.mdi-file-download-outline(@click='download(arq.id)') &nbsp {{ arq.nomeExibicao }}

        el-button(slot='footer', size='mini', @click='closeDialog()') {{ $t('mensagens.comuns.voltar') }}
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import LaudosService from '@/services/LaudosService';
import formatters from '@/utils/formatters';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import exibeCamposLaudo from './exibeCamposLaudo';
import TipoLaudo from '@/constants/TipoLaudo';

export default {
    name: 'ModalVisualizacaoLaudo',

    components: {
        Mapa
    },

    mixins: [exibeCamposLaudo],

    props: {
        idLaudo: {
            type: Number | null,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        },
        dialogTitle: {
            type: String,
            required: false,
            default() {
                return this.$t('mensagens.laudos.solicitacaoDeLaudo');
            }
        },
        tipoLaudo: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            TipoLaudo,
            informacoesLaudo: {
                nomeTerritorio: '',
                localidadeTerritorio: {},
                areaTerritorio: null,
                carsTerritorio: [],
                representantesTerritorio: [],
                car: null,
                representantes: [],
                arquivosLaudos: [],
                referenciaBacen: null,
                culturaEsperada: {},
                areaFinanciadaHa: null,
                producaoEsperadaTon: null,
                produtividadeEsperadaScHa: null,
                dataPlantioFormatado: '',
                dataColheitaFormatado: '',
                nomeRepresentante: '',
                cpfCnpjRepresentante: '',
                dataReferenciaFormatado: '',
                numeroOperacao: null,
                tipoEmpreendimento: null,
                observacao: null,
                descricao: null,
                baseDados: null,
                tipoInsumo: null,
                qdeEmitentes: null,
                cpr: null,
                matriculas: [],
                areaPenhor: null,
                formatoCoordenadas: null,
                proprietarios: []
            },
            fieldLocalidade: [],
            layersMaps: [],
            mapConfig: {
                controls: {}
            }
        };
    },

    methods: {
        getInformacoes() {
            if (!this.idLaudo) return;
            LaudosService.getInformacoesByIdLaudo(this.idLaudo)
                .then(({ data }) => {
                    this.informacoesLaudo = data;
                    this.mostrarTerritorioNoMapa();
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.laudos.erro.naoFoiPossivelBuscarAsInformacoesDoLaudo'
                        )
                    });
                });
        },

        numeralStringFormatToCpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },

        mostrarTerritorioNoMapa() {
            this.layersMaps = [];

            const layerTerritorio = {
                style: getEstiloGeometria('area'),
                name: 'Território Laudo',
                geoJson: this.informacoesLaudo.geometriaTerritorio
            };

            this.layersMaps.push(layerTerritorio);
        },

        closeDialog() {
            this.$emit('update:show', false);
        },

        download(idArquivo) {
            LaudosService.downloadArquivoLaudo(idArquivo)
                .then(() => {
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.laudos.downloadRealizadoComSucesso'
                        )
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.laudos.erro.erroAoRealizarDownload'
                        )
                    });
                });
        }
    },

    watch: {
        idLaudo() {
            this.getInformacoes();
        }
    },

    created() {
        this.getInformacoes();
    }
};
</script>

<style lang="scss">
#modal-visualizacao-laudo {
    b {
        margin-right: 5px;
    }
    
    .el-dialog__footer {
        margin-top: 0px;
        display: flex;
        justify-content: flex-start;
    }

    .mapa {
        height: 150px;
        border-radius: 4px;
        overflow: hidden;
        margin: 0 0 20px 0;
    }

    .margin-p {
        margin-bottom: 0;
    }

    ul.lista-cliente {
        overflow: auto;
        max-height: 130px;
    }

    .lista-cliente {
        @include scroll-bar();
        list-style: none;
        padding-inline-start: 0px;
        margin: 0;
        padding: 0;

        li {
            margin-bottom: 2px;
        }
    }

    .lista {
        margin-left: 15px;
    }

    .margin-p-block {
        margin-top: 15px;
    }

    ul.lista-car {
        overflow: auto;
        max-height: 130px;
    }

    .lista-car {
        @include scroll-bar();
        list-style: none;
        padding-inline-start: 0px;
        margin: 0;
        padding: 0;

        li {
            margin-bottom: 2px;
        }
    }

    .link {
        margin-left: 20px;
        cursor: pointer;
        i {
            display: inline-flex;
            vertical-align: bottom;
            font-style: normal;
            font-size: 13px;
        }
    }
}
</style>
